export class ApiError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "ApiError";
    }
}
async function request(path, init) {
    var _a, _b;
    const response = await fetch(`/api${path}`, Object.assign({ credentials: "include", headers: Object.assign({ "Content-Type": "application/json" }, init === null || init === void 0 ? void 0 : init.headers) }, init));
    if (!response.ok) {
        let message = response.statusText;
        try {
            const body = await response.json();
            message = (_b = (_a = body === null || body === void 0 ? void 0 : body.message) !== null && _a !== void 0 ? _a : body === null || body === void 0 ? void 0 : body.title) !== null && _b !== void 0 ? _b : message;
        }
        catch (_c) {
            // response had no JSON body; fall back to statusText
        }
        throw new ApiError(response.status, message);
    }
    if (response.status === 204) {
        return undefined;
    }
    return (await response.json());
}
export const apiClient = {
    get: (path) => request(path),
    post: (path, body) => request(path, { method: "POST", body: body === undefined ? undefined : JSON.stringify(body) }),
    put: (path, body) => request(path, { method: "PUT", body: JSON.stringify(body) }),
    delete: (path) => request(path, { method: "DELETE" }),
};
